
const _YB = _YB || {
    ab: function () {
        return _YB.dool ? "b" : "a" + Math.floor(Math.random() * 10);
    },
    dc: function () {
        return _YB.dool ? "d" : "c" + Math.floor(Math.random() * 20);
    },
    mx: function () {
        return !_YB.dool ? "x" : "m" + Math.floor(Math.random() * 180);
    },
    tt: function () {
        return "tt" + Math.floor(Math.random() * 10);
    },
    dool: Math.random() >= 0.1,
};

const setTargets = (slot) => {
    let _yt = new Date(),
        yb_th = _yt.getUTCHours() - 8,
        yb_tm = _yt.getUTCMinutes(),
        yb_wd = _yt.getUTCDay();
    if (yb_th < 0) {
        yb_th = 24 + yb_th;
        yb_wd -= 1;
    }
    if (yb_wd < 0) {
        yb_wd = 7 + yb_wd;
    }

    return slot
        .setTargeting("yb_ab", _YB.ab())
        .setTargeting("yb_dc", _YB.dc())
        .setTargeting("yb_mx", _YB.mx())
        .setTargeting("yb_tt", _YB.tt())
        .setTargeting("yb_ff", "" + Math.round(Math.random()))
        .setTargeting("yb_th", yb_th.toString())
        .setTargeting("yb_tm", yb_tm.toString())
        .setTargeting("yb_wd", yb_wd.toString())
}

export const generateAdSlot = (adUnit, size, reference, next, containerClass = '') => {
    // googletag.cmd.push(() => {
    //     const slot = setTargets(googletag
    //         .defineSlot(adUnit, size))
    //         .addService(googletag.pubads());
    //
    //     const container = document.createElement('div');
    //     container.setAttribute('id', slot.getSlotElementId());
    //     container.setAttribute('class', containerClass);
    //     reference.parentNode.insertBefore(container, next.nextSibling);
    //
    //     googletag.display(slot);
    //     //Yieldbird.refresh([slot]);
    //     googletag.pubads().refresh([slot]);
    // });
}

export const generateVideoSlot = (id, reference, next) => {
    const container = document.createElement('div');
    reference.parentNode.insertBefore(container, next.nextSibling);

    const aries = window.aries.v1;

    aries.commands.push(() => {
        const zoneId = `${id}`;
        aries.mount(zoneId, container, {
            width: 304,
            height: 171,
        });
    });
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/adManager.js